import { useQuery } from '@tanstack/react-query'
import { bookPackageKeys } from '../../../../data/queryFactories'
import { showErrorToast, toastKey } from '../../../../utils/showToast'
import { bookCollectionService } from '../../../../service/BookCollectionService'

function mapBookCollection(data) {
  return {
    createdAt: data?.createdAt,
    createdBy: data?.createdBy,
    name: data?.name,
    description: data?.description,
    uuid: data?.uuid,
    userGroupCount: data?.userGroupCount,
    bookCount: data?.bookCount,
  }
}

export default function useGetBookCollection() {
  const { data, isLoading, error } = useQuery({
    queryFn: async () => {
      const { success, message } = await bookCollectionService.getAll()
      if (!success) {
        throw new Error(message.content)
      }
      if (message?.content) {
        return { collections: message.content.map(mapBookCollection) }
      }
      throw new Error('Lấy danh sách gói sách')
    },
    queryKey: bookPackageKeys.list({ all: 1 }),
  })
  if (error) {
    showErrorToast({
      error: error.message,
      message: 'Lấy thông tin thất bại vui lòng liên hệ admin',
      toastId: toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET,
    })
  }
  return { data, isLoading }
}
